import { type FC } from "react";

import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Button, Colors } from "@snapchat/snap-design-system";

import noRoleAssignedLogoSvg from "@app-assets/svg/no-role-assigned-logo.svg";

import { Layout, PageHeader, PageSection, PageSubHeader, TopNavigation } from "../../../layout/components";
import { BUSINESS_MANAGER_URL } from "../../../shared/constants";
import { openWindow } from "../../../shared/utils/browser";

const sectionSize = css`
    width: 100%;
    max-width: 1080px;
    margin: 0 24px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    max-width: 1080px;
    height: 312px;
    margin-top: 16px;
    padding: 30px 16px 16px;

    background: ${Colors.WHITE};
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 6%);
`;

const Logo = styled.img`
    width: 99.41px;
    height: 87.28px;
`;

const Header = styled.span`
    margin-top: 42px;

    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: ${Colors.Black.V200};
    text-align: center;
`;

const Text = styled.span`
    width: 600px;
    margin: 16px 0 24px;

    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: ${Colors.Black.V50};
    text-align: center;
    letter-spacing: 0.2px;
`;

const openBusinessManager = () => openWindow(BUSINESS_MANAGER_URL);

export const NoRoleAssignedPage: FC = () => {
    return (
        <Layout>
            <TopNavigation />
            <PageSection sectionContainerClassName={sectionSize}>
                <PageHeader>My Community Lenses</PageHeader>
                <PageSubHeader>Manage your lenses and view insights</PageSubHeader>
                <Container>
                    <Logo alt="Warning triangle icon" src={noRoleAssignedLogoSvg} />
                    <Header> No Role Assigned</Header>
                    <Text>
                        Looks like you haven’t been assigned a role to your business account. Manage roles in Business
                        Manager.
                    </Text>
                    <Button type="primary" onClick={openBusinessManager}>
                        Go to Business Manager
                    </Button>
                </Container>
            </PageSection>
        </Layout>
    );
};
